import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1dc1da87"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=1dc1da87&lang=css"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc1da87')) {
      api.createRecord('1dc1da87', component.options)
    } else {
      api.reload('1dc1da87', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1dc1da87", function () {
      api.rerender('1dc1da87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageWrapper/index.vue"
export default component.exports